import { ajax } from '../../../services/helper'

class ApiService {
    resetPassword = (data,user_id) => {
        return new Promise((resolve, reject) => {
            const url = "/v1/users/"+user_id+"/resetPassword"
            ajax(url, 'POST', data)
                .then(res => resolve(res))
                .catch(err => reject(err))
        })
    }
}

export default new ApiService()


// WEBPACK FOOTER //
// ./src/modules/ResetPassword/services/apiservices.js